export const truncateLabel = (label: string, max: number) => {
  return label.length > max ? label.substring(0, max) + '...' : label;
};
